import lazyWithReload from 'config/ChunkReload';
import { menuBuilder } from 'services/Routes.service';
import { SettingsIcon } from '@edusynch/edusynch-svg-icons';

const SettingsGeneralContainer = lazyWithReload(() =>
  import('modules/Settings/Settings.container')
);

const ApiLogContainer = lazyWithReload(() =>
  import('modules/Settings/ApiLog/ApiLogList/ApiLogList.container')
);

const NotificationsContainer = lazyWithReload(() =>
  import(
    'modules/Settings/Notifications/NotificationsList/NotificationsList.container'
  )
);

const AiEvaluatorContainer = lazyWithReload(() =>
  import('modules/Settings/AIEvaluator/AIEvaluator.container')
);

const FeatureFlagsContainer = lazyWithReload(() =>
  import(
    'modules/Settings/FeatureFlags/FeatureFlagsList/FeatureFlagsList.container'
  )
);

const AccessLogsContainer = lazyWithReload(() =>
  import('modules/Settings/AccessLogs/AccessLogsList/AccessLogsList.container')
);

const AuditLogsContainer = lazyWithReload(() =>
  import('modules/Settings/AuditLogs/AuditLogsList/AuditLogsList.container')
);

const SettingsMenu = menuBuilder([
  {
    Icon: SettingsIcon,
    name: 'Settings',
  },
]).addSubmenu([
  {
    name: 'General',
    path: '/settings',
    component: SettingsGeneralContainer,
    ability: 'settings_web_mobile',
  },
  {
    name: 'API Log',
    path: '/api-log',
    component: ApiLogContainer,
    ability: 'settings_api_log',
  },
  {
    name: 'Push Notifications',
    path: '/push-notifications',
    component: NotificationsContainer,
    ability: 'settings_push_notifications',
  },
  {
    name: 'AI Evaluator Bot',
    path: '/ai-evaluator',
    component: AiEvaluatorContainer,
    ability: 'settings_web_mobile',
  },
  {
    name: 'Feature Flags',
    path: '/feature-flags',
    component: FeatureFlagsContainer,
    ability: 'settings_feature_flags',
  },
  {
    name: 'Audit Trail',
    path: '/audit-logs',
    component: AuditLogsContainer,
    ability: 'settings_audit_logs',
  },
  {
    name: 'Access Logs',
    path: '/access-logs',
    component: AccessLogsContainer,
    ability: 'settings_access_logs',
  },
]);

export default SettingsMenu;
